/* eslint-disable no-unused-vars */
import React, { FC } from 'react'
import './ApplicationForm.scss'
import BasicInfo from '../BasicInfo/BasicInfo'
import Nok from '../Nok/Nok'
import SSCE from '../SSCE/ssce'

interface dataTypes {
  register: any
  errors: any
  handleChange: (Value: any) => void
  values: any
  saveV: any
}

const ApplicationForm: React.FC<dataTypes> = ({ register, errors, handleChange, values, saveV }) => {
  return (
    <div className="application-form-modern">
      <BasicInfo register={register} errors={errors} handleChange={handleChange} values={values} saveV={saveV} />
      <Nok register={register} errors={errors} handleChange={handleChange} values={values} />
      <SSCE register={register} errors={errors} handleChange={handleChange} values={values} />
    </div>
  )
}

export default ApplicationForm
